import React, {useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Button, Card, message, Upload} from "antd";
import * as api from "../../apis/qualification";
import {useRequest} from "ahooks";
import * as minio from "../../utils/minio";
import * as util from "../../utils/utils";
import * as utils from "../../utils/utils";


function Qualification() {

    const [files, setFiles] = useState<any[]>([])

    const {run, loading} = useRequest(uploadFiles, {
        manual: true,
        onSuccess: () => {
            setFiles([])
            message.success("上传成功")
        },
        onError: (error: any) => {
            message.error(error)
        }
    })

    async function uploadFiles() {
        for (const file of files) {
            const key = utils.generateFileName(`qualification/`, file.name);
            if (key.indexOf('#') == -1) {
                throw "文件名缺少#号，请重新命名再上传！"
            }
            if (key.indexOf(" ") != -1) {
                throw "文件名存在空格，请重新命名再上传！"
            }
            await minio.upload(file.originFileObj, key)
            await api.addQualifications(file.name, key)
        }
    }

    return (
        <PageHeaderLayout>
            <Card title={(
                <>
                    <span>质检报告</span>
                    <span style={{fontSize: 12}}>（附件最大20M，支持格式：PDF, Word. Excel. TXT. JPG. PNG. BMP、 GIF, RAR. ZIP)</span>
                </>
            )}>
                <div style={{fontSize: 12, color: 'red',}}>
                    注：文件命名规则“商品编号#批号”，示例：1.06.3101#B230100531.PDF。
                </div>
                <div style={{margin: "15px 0", width: 500}}>
                    <Upload multiple={true} fileList={files} onChange={info => {
                        setFiles(info.fileList)
                    }} beforeUpload={() => false}>
                        <Button>浏览</Button>
                    </Upload>
                </div>
                <Button type={'primary'} loading={loading} onClick={() => run()}>上传</Button>
            </Card>
        </PageHeaderLayout>
    )
}

export default Qualification
